import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  // const currentURL = window.location
  // const jsonRoute = `${currentURL.toString()}.json`
  // const jsonData = {}
  // function checkAdmin(selectValue) {
  //   if (selectValue === jsonData.specialist_role) {
  //     $('.admin_link').show()
  //   } else {
  //     $('.admin_link').hide()
  //   }
  // }

  // function initEventListener() {
  //   $('#user_functional_role').on('change', function () {
  //     checkAdmin(this.value)
  //   })
  // }

  // $.getJSON(jsonRoute)
  //   .done((data) => {
  //     jsonData = data
  //     const initialSelectValue = $('#user_functional_role').val()
  //     checkAdmin(initialSelectValue)
  //     initEventListener(data)
  //   })
  //   .fail(() => {
  //     /* eslint-disable-next-line no-console */
  //     console.error('Failed to fetch JSON data')
  //   })
})
